import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import { pick } from 'lodash';

import displayName from 'component-lib/displayName';

import FormLabel from '../FormLabel';
import SoftLimitTextArea from '../SoftLimitTextArea';

import styles from './style.scss';

export default function SoftLimitTextAreaWithLabel(props) {
    const {
        label, description, value,
        limit, name, inputStyle, remainingStyle,
        required, error,
    } = props;
    const remaining = limit - value.length;
    const remainingLabelClass = remaining < 0
        ? 'character-count-over' : 'character-count';

    const remainingProps = {
        className: cx(remainingStyle, styles[remainingLabelClass]),
        'data-remaining': remaining,
    };

    if (remaining < 0) {
        remainingProps['data-error'] = name;
    }

    const softLimitTextAreaProps = pick(
        props,
        'disabled', 'name', 'onChange', 'value', 'limit', 'error', 'minHeight',
        'showRemaining',
    );

    return (
        <div className={styles.container}>
            <FormLabel hint={description} required={required}>
                {label}
            </FormLabel>
            <div className={styles['field-container']}>
                <span className={cx(inputStyle, styles.input)}>
                    <SoftLimitTextArea {...softLimitTextAreaProps} />
                </span>
            </div>
            {error && <div data-error className={styles.error}>
                {error}
            </div>}
        </div>
    );
}

SoftLimitTextAreaWithLabel.displayName = displayName('Forms/SoftLimitTextAreaWithLabel');

SoftLimitTextAreaWithLabel.propTypes = {
    label: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    limit: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    inputStyle: PropTypes.string,
    remainingStyle: PropTypes.string,
    required: PropTypes.bool,
    error: PropTypes.any,
    showRemaining: PropTypes.bool,
    disabled: PropTypes.bool,
};

SoftLimitTextAreaWithLabel.defaultProps = {
    inputStyle: '',
    remainingStyle: '',
    required: true,
    error: null,
    showRemaining: true,
    disabled: false,
};
